import AuditLogsComponent from '../../components/admin/AuditLogs';

/**
 * Container component for the Audit Logs feature
 * This helps with code organization and keeps router configuration simpler
 */
const AuditLogs = () => {
  return <AuditLogsComponent />;
};

export default AuditLogs;